import React, { lazy, Suspense, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './redux/selectors/AuthSelectors';
import Index from './views';
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { UserRightsProvider } from './context/UserRightsContext';
import axios from 'axios';
import packageJson from '../package.json';  // Import the whole package.json

const ForgotPassword = lazy(() => import('./views/pages/auth/ForgotPassword'));
const Login = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import('./views/pages/auth/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentVersion = packageJson.version;  // Get the version from package.json
  
  useEffect(() => {
    checkAutoLogin(dispatch, navigate);
  }, [dispatch, navigate]);

  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        const response = await axios.get('/meta.json');
        const latestVersion = response.data.version;

        if (latestVersion !== currentVersion) {
          setNewVersionAvailable(true);
        }
      } catch (error) {
        console.error('Error checking for updates:', error);
      }
    };

    checkForUpdates();
  }, [currentVersion]);

  const refreshApp = () => {
    window.location.reload(true); // Forces the browser to reload and bypass cache
  };

  const routeblog = (
    <Routes>
      <Route path='/auth/login' element={<Login />} />
      <Route path='/auth/forgot-password' element={<ForgotPassword />} />
    </Routes>
  );

  return (
    <div className="App">
      {props.isAuthenticated ? (
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }>
          <UserRightsProvider>
            <Index /> 
          </UserRightsProvider>
        </Suspense>
      ) : (
        <div className="vh-100">
          <Suspense fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }>
            <UserRightsProvider>
              {routeblog}
            </UserRightsProvider>
          </Suspense>
        </div>
      )}

      {newVersionAvailable && (
        <div className="update-notification">
          <p>A new version is available!</p>
          <button onClick={refreshApp}>Update Now</button>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

export default withRouter(connect(mapStateToProps)(App));
